import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, LogIn } from 'lucide-react';
import { BRAND } from '@/data/content';
import { useCounsellingModal } from './CounsellingModal';
import { isCareersSignedIn } from '@/lib/careersSession';

const NAV_ITEMS = [
  { label: 'Home', path: '/' },
  { label: 'Study in Italy', path: '/italy' },
  { label: 'MBBS Abroad', path: '/mbbs' },
  { label: 'Universities', path: '/universities' },
  { label: 'Career Portal', path: '/careers' },
  { label: 'Success Stories', path: '/success' },
  { label: 'Scholarships', path: '/scholarships' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [signedIn, setSignedIn] = useState(false);
  const location = useLocation();
  const { open } = useCounsellingModal();

  useEffect(() => {
    const handle = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handle);
    return () => window.removeEventListener('scroll', handle);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  // Refresh the signed-in state on route change so the Sign In button flips
  // to "Dashboard" the moment the user comes back from the Careers app.
  useEffect(() => { setSignedIn(isCareersSignedIn()); }, [location.pathname]);

  const signInPath = signedIn ? '/careers/dashboard' : '/careers/login';
  const signInLabel = signedIn ? 'Dashboard' : 'Sign In';

  return (
    <nav className={`ee-navbar ${scrolled ? 'scrolled' : ''}`} data-testid="navbar">
      <div className="container ee-nav-inner">
        <Link to="/" className="ee-logo" data-testid="logo-link">
          <img src={BRAND.logo} alt="EuroElite" />
          <div>
            <div className="ee-logo-text">EUROELITE</div>
            <div className="ee-logo-subtitle">Education Consultancy</div>
          </div>
        </Link>

        <ul className={`ee-nav-menu ${mobileOpen ? 'mobile-open' : ''}`}>
          {NAV_ITEMS.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={location.pathname === item.path ? 'active' : ''}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="ee-nav-actions">
          <Link
            to={signInPath}
            className="ee-nav-signin"
            data-testid="nav-signin-btn"
          >
            <LogIn size={14} /> {signInLabel}
          </Link>
          <button
            className="ee-nav-cta"
            onClick={() => open({ source: 'navbar' })}
            data-testid="nav-book-cta"
          >
            Book Free Counselling
          </button>
        </div>

        <button
          className="ee-mobile-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {mobileOpen ? <X size={24} color="#d4a849" /> : <Menu size={24} color="#d4a849" />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
